const normalizeBasePath = (path) => {
    if (!path) return "";
    const clean = String(path).trim();
    if (!clean || clean === "/") return "";
    return clean.startsWith("/") ? clean.replace(/\/$/, "") : `/${clean.replace(/\/$/, "")}`;
};

export const ORBIS_BASE_PATH = normalizeBasePath(
    import.meta.env.VITE_ORBIS_BASE_PATH || "/orbispmo"
);

export const API_BASE = `${ORBIS_BASE_PATH}/api`;

export const ORBIS_INSTANCE_CODE =
    import.meta.env.VITE_ORBIS_INSTANCE_CODE || "clip";
